import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sfx-card__icon-row q-mr-xs"
}

import { QImgProps } from "quasar"
import SfxIconRow from "src/components/special/SfxIconRow.vue"
import { SFX_CARD_HEIGHT, SFX_CARD_IMG_WIDTH } from "src/util/constants/configurations"
import { IMG_PLACEHOLDER } from "src/util/constants/files"
import { IconRowElement } from "src/util/types/components/sfxIconRow"
import { computed, PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCard',
  props: {
  active: {
    type: Boolean,
    default: false,
  },

  clickable: {
    type: Boolean,
    default: false,
  },

  closed: {
    type: Boolean,
    default: false,
  },

  imgSrc: {
    type: String,
    default: undefined,
  },

  imgBgColor: {
    type: String,
    default: undefined,
  },

  imgFit: {
    type: String as PropType<QImgProps["fit"]>,
    default: "cover",
  },

  hasImg: {
    type: Boolean,
    default: false,
  },

  imgPlaceholder: {
    type: String,
  },

  iconRow: {
    type: Array as PropType<IconRowElement[]>,
    default: (): IconRowElement[] => [],
  },

  bordered: {
    type: Boolean,
    default: true,
  },

  height: {
    type: Number,
    default: SFX_CARD_HEIGHT,
  },
},
  emits: ["click", "clickCtrl", "clickShift", "clickMeta"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const classes = computed(() => {
  return {
    "sfx-card--active": props.active,
    "sfx-card--hoverable": props.clickable,
    "sfx-card--closed": props.closed,
    "cursor-pointer": props.clickable,
  }
})

const cardSize = computed(() => props.height.toString() + "px")

const cardStyles = computed(() => {
  return {
    "max-height": cardSize.value,
  }
})

// Subtract 4px because of the card's borders (2px each)
const imgHeight = String(props.height - 4) + "px"

const imgStyles = computed(() => {
  return {
    "background-color": props.imgBgColor,
    height: imgHeight,
    width: SFX_CARD_IMG_WIDTH,
    "min-width": SFX_CARD_IMG_WIDTH,
  }
})

const placeholder = computed(() => props.imgPlaceholder ?? IMG_PLACEHOLDER)

//endregion

//region Functions

function clearMemory(src: string) {
  URL.revokeObjectURL(src)
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_card, {
    bordered: props.bordered,
    flat: "",
    class: _normalizeClass(["sfx-card", classes.value]),
    style: _normalizeStyle(cardStyles.value),
    onClick: [
      _cache[0] || (_cache[0] = _withModifiers(($event: any) => (props.clickable ? emit('click') : undefined), ["exact"])),
      _cache[1] || (_cache[1] = _withModifiers(($event: any) => (props.clickable ? emit('clickCtrl') : undefined), ["ctrl"])),
      _cache[2] || (_cache[2] = _withModifiers(($event: any) => (props.clickable ? emit('clickShift') : undefined), ["shift"])),
      _cache[3] || (_cache[3] = _withModifiers(($event: any) => (props.clickable ? emit('clickMeta') : undefined), ["meta"]))
    ]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, {
        horizontal: Boolean(props.hasImg || _ctx.$slots.graphics)
      }, {
        default: _withCtx(() => [
          (props.hasImg)
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 0,
                src: props.imgSrc,
                onLoad: clearMemory,
                style: _normalizeStyle(imgStyles.value),
                "placeholder-src": placeholder.value,
                fit: props.imgFit
              }, null, 8, ["src", "style", "placeholder-src", "fit"]))
            : _createCommentVNode("", true),
          (_ctx.$slots.graphics)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "sfx-card__graphics",
                style: _normalizeStyle(imgStyles.value)
              }, [
                _renderSlot(_ctx.$slots, "graphics")
              ], 4))
            : _createCommentVNode("", true),
          (Boolean(props.hasImg || _ctx.$slots.graphics))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_q_separator, {
                  vertical: "",
                  inset: "",
                  class: "rounded-borders"
                }),
                _createVNode(_component_q_card_section, {
                  class: "full-height full-width",
                  style: {"min-width":"0"}
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  _: 3
                })
              ], 64))
            : _renderSlot(_ctx.$slots, "default", { key: 3 })
        ]),
        _: 3
      }, 8, ["horizontal"]),
      (props.iconRow?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(SfxIconRow, {
              icons: props.iconRow
            }, null, 8, ["icons"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["bordered", "class", "style"])), [
    [_directive_ripple]
  ])
}
}

})